module.exports = __webpack_public_path__ + "static/media/modal-close-button.b9e27386.svg";